import type { FocusEvent, KeyboardEvent } from "react";
import "./form-inputs.style.scss";

interface MultipleTagsInputProps {
	label?: string;
	name?: string;
	error?: string;
	disabled?: boolean;
	autoComplete?: string;
	tagsArray?: string[];
	onKeyDown: (e: KeyboardEvent<HTMLInputElement>) => void;
	onBlur: (e: FocusEvent<HTMLInputElement>) => void;
	onTagRemove: (index: number) => void;
}

function MultipleTagsInput({
	label,
	name,
	error,
	disabled,
	tagsArray,
	onKeyDown,
	onBlur,
	onTagRemove,
}: MultipleTagsInputProps) {
	return (
		<div className="input-item">
			{label && <label className="input-label">{label}</label>}
			<input
				className="input-box-wrapper"
				type="text"
				name={name}
				placeholder="Enter tags separated by #"
				onKeyDown={onKeyDown}
				onBlur={onBlur}
				autoComplete="off"
				disabled={disabled}
			/>
			{error && <div className="validation-error">{error}</div>}
			<div className="tags-wrapper">
				{Array.isArray(tagsArray) &&
					tagsArray.length > 0 &&
					tagsArray.map((tag, index) => (
						<div className="tag-container" key={index}>
							<span className="tag-item">{tag}</span>
							{!disabled && (
								<span
									className="tag-close"
									onClick={() => onTagRemove(index)}
								>
									&times;
								</span>
							)}
						</div>
					))}
			</div>
		</div>
	);
}

export default MultipleTagsInput;
